import {useState} from 'react'
import {Button, Dropdown} from '@/components/atoms'

function CategoryWrapper() {
  const [selectedCategory, setSelectedCategory] = useState(null)

  const handleReset = () => {
    // Reset the selected category
    setSelectedCategory(null)
  }
  const handleCategoryChange = value => {
    setSelectedCategory(value)
  }

  return (
    <>
      <div className="category-header-wrap mb-6">
        <h1 className="category-header float-left">Select Categories to Include</h1>
        <Button
          handleButton={handleReset}
          uiSchema={{
            className: 'float-right',
            size: 'medium',
            title: 'Reset',
            variant: 'secondary',
            isDark: true,
          }}
        />
      </div>
      <div className="grid grid-cols-4">
        <Dropdown
          isJsonWrap={false}
          childList={[
            {
              displayText: 'All Category',
              id: '1',
              isBadge: false,
            },
            {
              displayText: 'Category 1',
              id: '2',
              isBadge: false,
            },
            {
              displayText: 'Category 2',
              id: '3',
              isBadge: false,
            },
          ]}
          isDark={true}
          label="Category *"
          placeholder="Select Categories"
          selection="single"
          updateValue={handleCategoryChange}
          size="medium"
          value={selectedCategory}
        />
      </div>
    </>
  )
}

export default CategoryWrapper
